import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import checkFromView from '@/views/checkFromView.vue'
import abnormalFromViewVue from '@/views/abnormalFromView.vue'
import logoViewVue from '@/views/logoView.vue'
import logoCheckViewVue from '@/views/logoCheckView.vue'
import meansVue from '@/views/means.vue'
import landingVue from '@/views/landing.vue'
import abnormalViewVue from '@/views/abnormalView.vue'
import deviceFromViewVue from '@/views/deviceFromView.vue'
import logoDeviceViewVue from '@/views/logoDeviceView.vue'
import AbnormalHomeVue from '@/views/AbnormalHome.vue'
import fireExtinguisherVue from '@/views/checkMould/fireExtinguisher.vue'
import fireHydrantVue from '@/views/checkMould/fireHydrant.vue'
import smokeDetectorVue from '@/views/checkMould/smokeDetector.vue'
import landingLoginVue from '@/views/landingLogin.vue'

Vue.use(VueRouter)

const routes = [
  
  
  // { 
  //   path: '/',
  //   redirect: '/landing'
  // },
  {
    path: '/home',
    name: '首页',
    component: HomeView
  },
  {
    path: '/landing',
    name: '登录页面',
    component: landingVue
  },
  // {
  //   path: '/login',
  //   name: '测试登录',
  //   component: landingLoginVue
  // },
  {
    path: '/check',
    name: '异常填报界面',
    component: checkFromView
  },
  {
    path: '/logoCheck',
    name: '异常填报完成页面',
    component: logoCheckViewVue
  },
  {
    path: '/',
    name: '品牌资料下载页面',
    component: meansVue
  },
  {
    path: '/device',
    name: '设备录入界面',
    component: deviceFromViewVue
  },
  {
    path: '/logoDevice',
    name: '设备录入完成界面',
    component: logoDeviceViewVue
  },  
  {
    path: '/AbnormalHome',
    name: '点检系统模板页面',
    component: AbnormalHomeVue
  },
  {
    path: '/abnormalView',
    name: '通用点检填报',
    component: abnormalViewVue
  },
  {
    path: '/fireExtinguisher',
    name: '灭火器点检填报',
    component: fireExtinguisherVue
  },
  {
    path: '/fireHydrant',
    name: '消防栓点检填报',
    component: fireHydrantVue
  },
  {
    path: '/smoke',
    name: '烟感报警点检填报',
    component: smokeDetectorVue
  },
  {
    path: '/logoView',
    name: '点检填报完成页面',
    component: logoViewVue
  },
]


const router = new VueRouter({
  routes
})

export default router
